import { FC } from 'react';
import { Auth } from '@barracuda/shared';
import { useAppContext } from '@/context/App.context';
import { Box, SxProps, Theme } from '@mui/material';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import { mixpanelApi } from '@barracuda/shared/analytics/mixpanel';

export const Logout: FC<{ children: JSX.Element | JSX.Element[]; sx?: SxProps<Theme> }> = ({
  children,
  sx = {}
}) => {
  const { user, setUser, setIsLoggedIn, setPurchaseBlockedReason } = useAppContext();
  const navigate = useLocalizedNavigate();

  const handleLogout = () => {
    mixpanelApi.onLogout();

    Auth.logout(user?.profile?.loggedBefore);
    setUser(undefined);
    setIsLoggedIn(false);
    navigate('/login');
    setPurchaseBlockedReason?.(undefined);
  };

  return (
    <Box component='span' sx={{ ...sx, cursor: 'pointer' }} onClick={handleLogout}>
      {children}
    </Box>
  );
};
